'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.blue = exports.orange = exports.green = exports.yellow = exports.red = exports.lighterGrey = exports.lightGrey = exports.grey = exports.marine = exports.navy = exports.white = exports.lightBlack = exports.black = undefined;

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var swatch = function swatch(value) // eslint-disable-line no-unused-vars
{
  var contrast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dark';

  var c = (0, _color2['default'])(value);
  var w = (0, _color2['default'])('white');
  var b = (0, _color2['default'])('black');
  return {
    25: c.mix(w, 0.05).hex(),
    50: c.mix(w, 0.1).hex(),
    100: c.mix(w, 0.2).hex(),
    200: c.mix(w, 0.4).hex(),
    300: c.mix(w, 0.6).hex(),
    400: c.mix(w, 0.8).hex(),
    500: c.hex(),
    600: c.mix(b, 0.8).hex(),
    700: c.mix(b, 0.6).hex(),
    800: c.mix(b, 0.4).hex(),
    900: c.mix(b, 0.2).hex(),
    A100: c.mix(w, 0.2).hex(),
    A200: c.mix(w, 0.4).hex(),
    A400: c.mix(w, 0.8).hex(),
    A700: c.mix(b, 0.6).hex(),
    contrastDefaultColor: 'dark'
  };
};

var black = exports.black = '#000000';
var lightBlack = exports.lightBlack = 'rgba(0, 0, 0, 0.54)';
var white = exports.white = '#ffffff';
var navy = exports.navy = swatch('#3e4158', 'light');
var marine = exports.marine = swatch('#44b6b7');
var grey = exports.grey = swatch('#808080');
var lightGrey = exports.lightGrey = '#d4d9e2';
var lighterGrey = exports.lighterGrey = '#8C96A9';
var red = exports.red = swatch('#db5656', 'light');
var yellow = exports.yellow = swatch('#ffc51e');
var green = exports.green = swatch('#65b568', 'light');
var orange = exports.orange = swatch('#f16c37', 'light');
var blue = exports.blue = swatch('#617fe2', 'light');


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/styles/colors.js
// module id = 564
// module chunks = 32